/* eslint-disable id-blacklist */

import Hashids from "hashids";

/**
 * Import:
 *     import "@extensiones/StringExtension";
 *
 * Uso:
 *     const numero = "hash".decode("clave")
 */

declare global {
    interface String {
        decode(clave: string): number;
        sacarCaracteresEdicion(): string;
        sacarTildes(): string;
    }
}

String.prototype.decode = function(clave: string): number {
    const arrayDecode = new Hashids(clave).decode(this);
    return arrayDecode[0] as number;
};

String.prototype.sacarCaracteresEdicion = function(): string {
    return this.replace(/\*/g, "");
};

String.prototype.sacarTildes = function(): string {
    const tildes = [["á", "a"], ["é", "e"], ["í", "i"], ["ó", "o"], ["ú", "u"]];
    let palabraEnLower: string = this.toLowerCase();

    tildes.forEach(parTilde => {
        palabraEnLower = palabraEnLower.replace(new RegExp(parTilde[0], "g"), parTilde[1]);
    });

    return palabraEnLower;
};
